<template>
    <div>
        <Modal
            v-model="showModal"
            draggable
            sticky
            :title="title"
            width="600"
            no-footer
            :closable="closable"
            class="createRequest"
            :before-close="handleReset"
        >
            <Form
                ref="form"
                :model="form"
                :rules="isDisabled ? ruleInline : ruleInlineWithCreatedAt"
                :loading="isLoading"
                label-position="left"
                class="create-time-dispute-wrapper"
            >
                <Row>
                    <Col span="8">
                        <FormItem label="Pay Period From">
                            {{ payslip.payslip.details.pay_period_from }}
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="Pay Period To">
                            {{ payslip.payslip.details.pay_period_to }}
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="Payroll Run">
                            {{ payslip.payslip.details.payroll_run }}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <FormItem label="File">
                            <Button class="pt-btn-3" :loading="isLoading" @click="triggerDownload"> Download </Button>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <FormItem label="Pin">
                            {{ payslip.pin }}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div>
                <Button class="pt-btn-2" style="margin-right: 10px" @click="handleCancel"> CANCEL </Button>
                <!--                <Button v-if="!forEdit && !enableForUpdate" class="pt-btn-3" :loading="isLoading" @click="handleSubmit"> SUBMIT </Button>-->
                <!--                <Button v-if="enableForUpdate" class="pt-btn-3" :loading="isLoading" @click="handleUpdate"> UPDATE </Button>-->
                <!--                <Button-->
                <!--                    v-if="forEdit && form.status === 'pending' && userType === 'admin'"-->
                <!--                    class="pt-btn-3"-->
                <!--                    :loading="isLoading"-->
                <!--                    :disabled="file == null"-->
                <!--                    @click="handleApprove"-->
                <!--                >-->
                <!--                    Approve-->
                <!--                </Button>-->
            </div>
        </Modal>
    </div>
</template>
<script>
import moment from 'moment';
import { downloadPayslip, showPayslipPin } from '@/services/payroll.services';

export default {
    data() {
        return {
            title: 'Download Payslip',
            isLoading: false,
            options: null,
            closable: false,
            enableForUpdate: false,
            form: {
                path: '',
            },
            userType: null,
            isDisabled: false,
            showModal: false,
            userId: null,
            payslip: {},
        };
    },
    created() {
        this.options = {
            disabledDate(date) {
                const isCurrentDate = date && moment(date).format('DD-MMM-YYYY') == moment().format('DD-MMM-YYYY');
                return isCurrentDate ? false : date && date.valueOf() > Date.now() - 86400000;
            },
        };
    },
    methods: {
        async openPayslipModal(data) {
            const { data: request } = await downloadPayslip({ id: data.payslip });
            this.payslip = request;
            this.isLoading = false;
            this.showModal = true;
        },
        async triggerDownload() {
            window.open(this.payslip.url, '_blank').focus();
            // const link = document.createElement('a');
            // link.href = this.payslip.url;
            // link.setAttribute('download', 'test.pdf'); //or any other extension
            // document.body.appendChild(link);
            // link.click();
            // this.isLoading = false;
            this.retrievePin();
        },
        async retrievePin() {
            this.isLoading = true;
            const { data } = await showPayslipPin({ id: this.payslip.payslip._id });
            this.payslip.pin = data.password;

            this.$nextTick(() => {
                this.isLoading = false;
            });
            console.log('retrievePin: ', data);
        },

        handleCancel() {
            this.isLoading = false;
            this.showModal = false;
            this.$refs.form.resetFields();
        },

        handleConfirm() {
            this.showModal = false;
        },

        handleReset() {
            this.$refs.form.resetFields();
        },
    },
};
</script>
<style lang="scss">
form.ivu-form.ivu-form-label-left.ivu-form-inline {
    border: unset;
    .ivu-form-item {
        display: inline-block !important;
        margin-right: 10px !important;
        vertical-align: top !important;
    }

    .ivu-form-item-content {
        margin-left: 0 !important;
        display: block !important;
    }
}
.createRequest .ivu-modal-body {
    padding: 16px;
}
.createRequest .ivu-modal-footer {
    display: none;
}
.createRequest .ivu-spin-main {
    justify-content: center;
    display: flex;
}
.create-time-dispute-wrapper {
    .ivu-form-item {
        display: inline-block !important;
        margin-right: 10px !important;
        vertical-align: top !important;
    }

    .ivu-form-item-content {
        margin-left: 0 !important;
        display: block !important;
    }
}

@media screen and (max-width: 767px) {
    .create-time-dispute-wrapper {
        .ivu-form-item {
            margin: 20px 5px;

            .ivu-form-item-content {
                margin-left: 0 !important;
                display: block !important;
            }
        }
    }
}
</style>
